import { render, staticRenderFns } from "./TrademarkOwnerForm.vue?vue&type=template&id=44ab69d0&"
import script from "./TrademarkOwnerForm.vue?vue&type=script&lang=js&"
export * from "./TrademarkOwnerForm.vue?vue&type=script&lang=js&"
import style0 from "./TrademarkOwnerForm.vue?vue&type=style&index=0&id=44ab69d0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports